import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import preciseToSecs from "./Utils";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ClipLoader from "react-spinners/ClipLoader";

const DateRangeDropdown = ({ dateRange, setDateRange }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dateRangeState, setDateRangeState] = useState(dateRange);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [applyClicked, setApplyClicked] = useState(false);
  const [headerText, setHeaderText] = useState("Last 15 Minutes");
  const [datePickerValue, setDatePickerValue] = useState({
    fromDate: null,
    toDate: null,
  });

  const updateHeaderText = (text) => {
    setHeaderText(text);
  };

  const updateHeaderTextSecondary = (fromDate, toDate) => {
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);

    const formattedFromDate = `${fromDateObj.getDate()}/${
      fromDateObj.getMonth() + 1
    }/${fromDateObj.getFullYear()} ${fromDateObj.getHours()}:${String(
      fromDateObj.getMinutes()
    ).padStart(2, "0")}`;
    const formattedToDate = `${toDateObj.getDate()}/${
      toDateObj.getMonth() + 1
    }/${toDateObj.getFullYear()} ${toDateObj.getHours()}:${String(
      toDateObj.getMinutes()
    ).padStart(2, "0")}`;

    const headerText = formattedFromDate + " - " + formattedToDate;
    setHeaderText(headerText);
  };

  const dropdownItemStyle = {
    border: "1px solid #007bff",
    backgroundColor: "#007bff",
    color: "#ffffff",
  };

  const dropdownItemHoverStyle = {
    backgroundColor: "#0069d9",
    color: "#ffffff",
  };

  const style = {
    color: "var(--text-medium, rgba(1, 1, 2, 0.60))",
    fontSize: "11px",
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "500",
    lineHeight: "14px",
    backgroundColor: "#FFFFFF",
    color: "#000000",
    marginLeft: "8px",
  };

  const applyButtonStyle = {
    backgroundColor: "#007bff",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    padding: "2px 6px",
    border: "1px solid transparent",
    borderRadius: "0.25rem",
  };

  const toggle = () => setDropdownOpen((prevState) => !prevState);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    setDateRangeState((prevState) => ({
      ...prevState,
      fromDate: date.toISOString(),
    }));
    setDatePickerValue((prevState) => ({
      ...prevState,
      fromDate: date.toISOString(),
    }));
  };

  const handleEndDateChange = (date) => {
    setEndDate(date);
    setDateRangeState((prevState) => ({
      ...prevState,
      toDate: date.toISOString(),
    }));
    setDatePickerValue((prevState) => ({
      ...prevState,
      toDate: date.toISOString(),
    }));
  };
  const handleFromDateChange = (minutes) => {
    const fromDate = preciseToSecs(
      new Date(new Date().getTime() - minutes * 60 * 1000)
    ).toISOString();
    setDateRangeState((prevState) => ({ ...prevState, fromDate }));
    setApplyClicked(true);
  };

  const handleApplyClick = (fromDate, toDate, headerText, toggleDropdown) => {
    if (headerText) {
      updateHeaderText(headerText);
    } else {
      updateHeaderTextSecondary(fromDate, toDate);
    }
    setApplyClicked(true);
    if (toggleDropdown) {
      toggleDropdown();
    }
  };

  const calculateInterval = (fromDate, toDate) => {
    const diff = new Date(toDate) - new Date(fromDate);
    console.log(diff);
    if (diff > 31 * 24 * 60 * 60 * 1000) {
      return "1M";
    } else if (diff > 24 * 60 * 60 * 1000 && diff < 31 * 24 * 60 * 60 * 1000) {
      return "1d";
    } else if (diff >= 60 * 60 * 1000 && diff <= 24 * 60 * 60 * 1000) {
      return "1h";
    } else if (diff < 60 * 60 * 1000) {
      return "1m";
    }
    return "1m";
  };

  useEffect(() => {
    let autoRefreshTimeout;

    const fetchData = () => {
      setLoading(true);
      const newToDate = datePickerValue.toDate
        ? datePickerValue.toDate
        : new Date().toISOString();
      const rangeInMilliseconds =
        new Date(newToDate) - new Date(dateRangeState.fromDate);
      const newFromDate = new Date(
        new Date(newToDate).getTime() - rangeInMilliseconds + 30000
      ).toISOString();

      setDateRangeState((prevState) => ({
        ...prevState,
        fromDate: newFromDate,
        toDate: newToDate,
      }));
      const calendarInterval = calculateInterval(newFromDate, newToDate);
      setDateRange({ ...dateRangeState, calendarInterval });

      setDatePickerValue({ fromDate: null, toDate: null });
      setLoading(false);
    };
    if (applyClicked) {
      fetchData();
      setApplyClicked(false);
      setDatePickerValue({ fromDate: null, toDate: null });
    } else {
      autoRefreshTimeout = setTimeout(() => {
        fetchData();
      }, 30000);
    }

    return () => {
      clearTimeout(autoRefreshTimeout);
    };
  }, [dateRangeState, setDateRangeState, setDateRange, applyClicked]);

  useEffect(() => {
    const fetchData = () => {
      setLoading(true);
      // const calendarInterval = calculateInterval(dateRange.fromDate, dateRange.toDate);
      // setDateRange({ ...dateRange, calendarInterval });
      console.log(dateRange);
      setLoading(false);
    };

    fetchData();
  }, []);

  return (
    <div>
      {/* {
      loading &&    
      <ClipLoader
      
        style={{
        color:'#007bff',
        loading:{loading},
        size:'150',
        ariaLabel:"Loading Spinner",
        dataTestid:"loader",
        position:"fixed",
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',  
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 9999,
      }}
      />  
      
    }  */}
      <div style={{ position: "relative" }}>
        <Dropdown isOpen={dropdownOpen} toggle={toggle} style={{ zIndex: 1 }}>
          <DropdownToggle style={style} caret>
            {headerText}
          </DropdownToggle>
          <DropdownMenu>
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div>
                <DropdownItem
                  style={{ fontWeight: "bold", fontSize: "inherit" }}
                  header
                >
                  Quick Shortcuts
                </DropdownItem>
                <div>
                  <DropdownItem
                    onClick={() => {
                      handleFromDateChange(15);
                      handleApplyClick(null, null, "Last 15 minutes");
                    }}
                  >
                    Last 15 minutes
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      handleFromDateChange(30);
                      handleApplyClick(null, null, "Last 30 minutes");
                    }}
                  >
                    Last 30 minutes
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      handleFromDateChange(60);
                      handleApplyClick(null, null, "Last Hour");
                    }}
                  >
                    Last hour
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      handleFromDateChange(24 * 60);
                      handleApplyClick(null, null, "Last 24 Hours");
                    }}
                  >
                    Last 24 Hours
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      handleFromDateChange(7 * 24 * 60);
                      handleApplyClick(null, null, "Last Week");
                    }}
                  >
                    Last Week
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      handleFromDateChange(15 * 24 * 60);
                      handleApplyClick(null, null, "Last 15 Days");
                    }}
                  >
                    Last 15 Days
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      handleFromDateChange(30 * 24 * 60);
                      handleApplyClick(null, null, "Last Month");
                    }}
                  >
                    Last Month
                  </DropdownItem>
                  <DropdownItem
                    onClick={() => {
                      handleFromDateChange(365 * 24 * 60);
                      handleApplyClick(null, null, "Last Year");
                    }}
                  >
                    Last Year
                  </DropdownItem>
                </div>
              </div>
              <div>
                <div className="p-2">
                  <label htmlFor="fromDate">From Date:</label>
                  <DatePicker
                    id="fromDate"
                    // value={datePickerValue}
                    selected={startDate}
                    onChange={handleStartDateChange}
                    dateFormat="Pp"
                    showTimeSelect
                    maxDate={endDate}
                  />
                </div>
                <div className="p-2">
                  <label htmlFor="toDate">To Date:</label>
                  <DatePicker
                    id="toDate"
                    // value={datePickerValue}
                    selected={endDate}
                    onChange={handleEndDateChange}
                    dateFormat="Pp"
                    showTimeSelect
                    minDate={startDate}
                    maxDate={new Date()}
                  />
                </div>
                <div style={{ marginLeft: "8px" }}>
                  <button
                    style={applyButtonStyle}
                    onClick={() => {
                      handleApplyClick(startDate, endDate, null, toggle);
                    }}
                  >
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  );
};

export default DateRangeDropdown;
